import React from "react";
import cvData from "../../data/cv";

const educationDetails = {
  "Master of Computer Applications": (
    <>
      <p>
        During my{" "}
        <strong>Master of Computer Applications (MCA) degree</strong>, I
        delved into advanced subjects such as{" "}
        <strong>software development</strong>,{" "}
        <strong>database management systems</strong>, and{" "}
        <strong>computer networks</strong>.
      </p>
      <ul>
        <li>
          I also explored <strong>web technologies</strong>,{" "}
          <strong>distributed computing</strong>,{" "}
          <strong>advanced algorithms</strong>, and{" "}
          <strong>mobile technology</strong>. Specialized electives in{" "}
          <strong>machine learning</strong>, <strong>cloud computing</strong>,
          and <strong>cybersecurity</strong> further enriched my knowledge.
        </li>
        <li>
          This program equipped me with a comprehensive and robust
          understanding of both theoretical concepts and practical applications
          in the field of <strong>computer science</strong>.
        </li>
      </ul>
    </>
  ),
  "Bachelor of Computer Applications": (
    <>
      <p>
        During my <strong>Bachelor of Computer Applications degree</strong>, I
        studied core subjects such as <strong>algorithms</strong>,{" "}
        <strong>data structures</strong>, <strong>computer architecture</strong>
        , and <strong>operating systems</strong>.
      </p>
      <ul>
        <li>
          I also delved into <strong>software engineering</strong>,{" "}
          <strong>database management</strong>,{" "}
          <strong>artificial intelligence</strong>, and{" "}
          <strong>cybersecurity</strong>.
        </li>
        <li>
          Elective courses allowed me to explore specialized areas like{" "}
          <strong>machine learning</strong>, <strong>web development</strong>,
          and <strong>mobile app development</strong>, providing a comprehensive
          and robust foundation in both theoretical and practical aspects of{" "}
          <strong>computer science</strong>.
        </li>
      </ul>
    </>
  ),
};

const Education = () => {
  return (
    <section
      className="colorlib-education"
      data-section="education"
      id="education"
    >
      <div className="colorlib-narrow-content">
        <div className="row">
          <div
            className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
            data-animate-effect="fadeInLeft"
          >
            <span className="heading-meta">Education</span>
            <h2 className="colorlib-heading animate-box">Academic Background</h2>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-12 animate-box"
            data-animate-effect="fadeInLeft"
          >
            <div className="fancy-collapse-panel">
              <div
                className="panel-group"
                id="accordion"
                role="tablist"
                aria-multiselectable="true"
              >
                {cvData.education.map((item, index) => {
                  const headingId = `headingEducation${index}`;
                  const collapseId = `collapseEducation${index}`;

                  return (
                    <div className="panel panel-default" key={item.degree}>
                      <div
                        className="panel-heading"
                        role="tab"
                        id={headingId}
                      >
                        <h4 className="panel-title">
                          <a
                            className="collapsed"
                            data-toggle="collapse"
                            data-parent="#accordion"
                            href={`#${collapseId}`}
                            aria-expanded="false"
                            aria-controls={collapseId}
                          >
                            {item.degree}
                            <span className="education-meta">
                              {item.institution} · {item.year}
                            </span>
                          </a>
                        </h4>
                      </div>
                      <div
                        id={collapseId}
                        className="panel-collapse collapse"
                        role="tabpanel"
                        aria-labelledby={headingId}
                      >
                        <div className="panel-body">
                          {educationDetails[item.degree]}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
